export type SearchType = "UPC" | "SKU";

export const getSearchParams = ({
  retailer,
  productSku,
  productUpc,
}: {
  retailer: string;
  productSku: string;
  productUpc?: string;
}): { searchCode: string; searchType: SearchType; usedUpc: boolean } => {
  const useUpc =
    (retailer === "home_depot" ||
      retailer === "dollar_general" ||
      retailer === "walmart" ||
      retailer === "lowes" ||
      retailer === "tractor_supply" ||
      retailer === "northern_tool" ||
      retailer === "samsclub") &&
    Boolean(productUpc);
  return {
    searchCode: useUpc ? (productUpc as string) : productSku,
    searchType: useUpc ? "UPC" : "SKU",
    usedUpc: useUpc,
  };
};

export const shouldFallbackToSku = ({
  retailer,
  productUpc,
  productSku,
}: {
  retailer: string;
  productUpc?: string;
  productSku?: string;
}): boolean => retailer === "walmart" && Boolean(productUpc) && Boolean(productSku);

export const getSearchErrorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : "Failed to search nearby stores";
